import { ApiActionTypes, buildApiTypeAction } from "src/common/apiLoader/apiLoaderUtils";

const GET_CASHBOX_CATEGORIES = 'GET_CASHBOX_CATEGORIES';
export const GET_CASHBOX_CATEGORIES_API = buildApiTypeAction(GET_CASHBOX_CATEGORIES, ApiActionTypes.REQUEST)
export const GET_CASHBOX_CATEGORIES_API_SUCCESS = buildApiTypeAction(GET_CASHBOX_CATEGORIES, ApiActionTypes.SUCCESS)
export const GET_CASHBOX_CATEGORIES_API_ERROR = buildApiTypeAction(GET_CASHBOX_CATEGORIES, ApiActionTypes.ERROR)

const UPSERT_CASHBOX_CATEGORY = 'UPSERT_CASHBOX_CATEGORY';
export const UPSERT_CASHBOX_CATEGORY_API = buildApiTypeAction(UPSERT_CASHBOX_CATEGORY, ApiActionTypes.REQUEST)
export const UPSERT_CASHBOX_CATEGORY_API_SUCCESS = buildApiTypeAction(UPSERT_CASHBOX_CATEGORY, ApiActionTypes.SUCCESS)
export const UPSERT_CASHBOX_CATEGORY_API_ERROR = buildApiTypeAction(UPSERT_CASHBOX_CATEGORY, ApiActionTypes.ERROR)

const CREATE_INCOME_RECORD = 'CREATE_INCOME_RECORD';
export const CREATE_INCOME_RECORD_API = buildApiTypeAction(CREATE_INCOME_RECORD, ApiActionTypes.REQUEST)
export const CREATE_INCOME_RECORD_API_SUCCESS = buildApiTypeAction(CREATE_INCOME_RECORD, ApiActionTypes.SUCCESS)
export const CREATE_INCOME_RECORD_API_ERROR = buildApiTypeAction(CREATE_INCOME_RECORD, ApiActionTypes.ERROR)

const GET_INCOME_RECORDS = 'GET_INCOME_RECORDS';
export const GET_INCOME_RECORDS_API = buildApiTypeAction(GET_INCOME_RECORDS, ApiActionTypes.REQUEST)
export const GET_INCOME_RECORDS_API_SUCCESS = buildApiTypeAction(GET_INCOME_RECORDS, ApiActionTypes.SUCCESS)
export const GET_INCOME_RECORDS_API_ERROR = buildApiTypeAction(GET_INCOME_RECORDS, ApiActionTypes.ERROR)